export class Customer { 
    public serviceid: number;
    public storeid: number;
    public area: string;
    public asccode: string;
    public contactdetail1: string;
    public id: number;
    public km: string;
    public maincompanyid: number;
    public name: string;
    public open: number;
    public pincode: string;
    public waittoken: string;
}